import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import GenericViewsToolbar from "../components/GenericViewsToolbar/GenericViewsToolbar";
import RawData from "../controllers/RawData/RawData";
import { REACT_APP_DEFAULT_PAGE_SIZE } from "../environmentVariables";

const queries = (args = {}) => {
    return [
        {
            resource: "raw_data",
            args: {
                entity: args.entityRawData || "",
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                modulePrefix: args.modulePrefix || "",
                importId: args.importId,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(args.pageSize || REACT_APP_DEFAULT_PAGE_SIZE),
            },
            body: `__typename, items, headerItems, metadata, filters(entity:$entity, modulePrefix:$modulePrefix){ prop, name, type, list, disableOperators, mandatory}`,
            downloadable: false,
            xlsxTranslation: args.entity,
            isDatagridReq: true,
        },
    ];
};

const rawData = (path, navigation, exact, navByImportId = false) => ({
    path,
    navigation,
    component: RawData,
    queries,
    exact,
    navByImportId,
    title: "label(param(entity))",
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).items",
                header: "query(0).headerItems",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                onRowEdit: true,
                hideDeleteSeriesButton: true,
                basePath: path,
                toolbar: GenericViewsToolbar,
                toolbarProps: {
                    data: "query(0).list",
                    exportableArray: "query(0).exportableEntities",
                },
                onRowClickCustom: () => {},
            },
        },
    ],
});

export default rawData;
